import { Component, OnInit, OnChanges, SimpleChanges, ViewChild, Input } from "@angular/core";
import { CommonService, CacService, ReportsService } from "../../services";
import { DashboardService , SubscribeService} from "../../services/index";
import * as _moment from "moment";
import Chart from "chart.js";
const moment = _moment;
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Subject } from 'rxjs/Subject';
import { EmployeeModel } from '../../model/index';
import { UserModel } from '../../model/index';
import { UserService } from '../../services/index';
import { FormControl } from '@angular/forms';
import { DashboardModel } from '../../model/index';

@Component({
  selector: "dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.scss"],
})
export class Dashboard implements OnInit, OnChanges {

  @Input() active = false;
  @Input() isCloseable = false;

  public pieChartLabels = ["Sales Q1", "Sales Q2", "Sales Q3", "Sales Q4"];

  // public pieChartData: SingleDataSet = [120, 150, 180, 90];
  // public pieChartType: ChartType = 'pie';
  brandsData: any;
  filterData: { branch: string; branch_id: number; date: Date; };
  loadingIndicator: boolean = true;
  top_from_date = new Date();
  count_from_date = new Date();
  from_date = new Date(); 
   to_date = new Date();
  service_from_date = new Date();
  isLoadMask: Promise<any>;
  targetRow = [
    {
      source: "Value",
      month_target: "",
      days_target: "",
      achived: "",
      yes_no: "",
      reason: "",
    },
  ];
  loading: boolean;
  sourceRow: any = [];
  conversionRow: any = [];
  aspRow: any = [];
  walkinRow: any = [];
  bilateralRow: any = [];
  comments: any;
  topSellingData: any = [];
  leastSellingData: any = [];
  salesSpareServiceCount: any = [];
  salesServiceSpareLable: any = [];
  salesBillCount: any = [];
  salesBillLable: any = [];
  sellingData:any=[];
  salesConvData: any = [];
  serviceValueData: any = [];
  targetData: any;
  achievedData: any;
  targetAchievedData: any[];

  turnOverLabel: any = [];
  turnOverData: any = [];
  monthlyTarget: any = [];
  targetAchieved: any = [];
  months: any = [];
  prevseventhMonth: string;
  monthlyTurOverCard: any = [];
  currentMonth: any;
  branchWiseLabel: any[];
  currentBranch: any;
  monthNames: string[];
  usernameComp:any=[];
  filteredEmp: Observable<any[]>;
  canvas: any;
  ctx: any;
  name: string;
  month:string;
  myBarChart: Chart;
  myBarChart1: Chart;
  monthList: any[];
  saleConvData = {
    "search_data": "",
    // "from_date":new Date(),
    // "to_date":new Date()
};
page = {
  limit: 25,
  count: 0,
  offset: 0,
  orderBy: 'username',
  orderDir: 'asc'
};
public addition :any = [];
  public display : any = [];
  concatarr:any=[];
userData = {
  "search_data": ""
};
  @ViewChild('filterPanel') filterPanel;
  branchData: any;
  user: any;
  username: any;
  salesAmt: any;
  spareAmt: any;
  serviceAmt: any;
  constructor(
    public subSer: SubscribeService,
    private dashboardService: DashboardService,
    private cacService: CacService,
    private reportsService: ReportsService, private userService: UserService
  ) {

  //   this.subSer.publishReloadHomeGrid().subscribe(($e) => {
  //     this.top_from_date = new Date();
  //     this.count_from_date = new Date();
  //     this.from_date = new Date(); 
  //     this.to_date = new Date();
  //     this.service_from_date = new Date();
  //     this.username = '';
  //     this.monthListType= 'Last 6 months';

  //     this.getTopLeastSelling();
  //         this.getSalesServiceSpareCount();
  //         this.getSalesMonthList();
  //         this.getUserList();
  //       this.getServiceValue();
  
  // });
    console.log("Helloo", this);

    this.monthList = ['Current Month', 'Last 3 months', 'Last 6 months'];
   
    this.monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    var today = new Date();
    var d;

    for (var i = 7; i > 0; i -= 1) {
      d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      var monthname = d.getMonth();
      if (d.getMonth() == 11) {
        monthname = 0;
      } else {
        monthname++;
      }
      this.months.push(this.monthNames[monthname]);
    }

    this.prevseventhMonth = this.months[0];
    this.currentMonth = this.months[this.months.length - 1];
    this.months = this.months.splice(1);
    
  }
  monthListType= 'Last 6 months';
 

  ngOnInit(): void {
  //   this.subSer.publishReloadHomeGrid().subscribe(($e) => {
  //     debugger;
  //     this.getTopLeastSelling();
  //     this.getSalesServiceSpareCount();
  //     this.getSalesMonthList();
  //     this.getUserList();
  //   this.getServiceValue();
  //     // that.pageCallback({ offset: 0 });
  //     // this.tabID = 'Dashboard';
  // });
    
    // this.getBrandsList();
    // this.getMeetingData();
    this.getTopLeastSelling();
    this.getSalesServiceSpareCount();
    this.getSalesMonthList();
    this.getUserList();
  this.getServiceValue();

    
  }

  ngAfterViewInit() {
    // this.setTurnOverChart();
    // this.initiateBranchWiseChart();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['active'] && changes['active'].currentValue === true) {
      setTimeout(() => {
        if (this.myBarChart) this.myBarChart.resize();
        if (this.myBarChart1) this.myBarChart1.resize();
      }, 50);
    }
  }

  setTurnOverChart() {
    if (this.myBarChart) {
     this.myBarChart.destroy();
    }
    this.canvas = document.getElementById("myChart1");
    this.ctx = this.canvas.getContext('2d');
    this.myBarChart = new Chart(this.ctx, {
      type: "pie",
      data: {
        // labels: this.salesServiceSpareLable,
        datasets: [
          {
            barThickness: 5,
            maxBarThickness: 5,
            minBarLength: 2,
            // labels: ["Sales", "Failed"],
            data: this.salesSpareServiceCount,

            backgroundColor: [
              "#F14B27",
              "#274FF1",
              "#898C96",
            ],
            borderColor: [
              "#fff"
            ],
            borderWidth: 1,
            borderRadius: 1,
            borderSkipped: true,

            // borderWidth: 1,
            // borderRadius: 5,
            // borderSkipped: false,
          },
        ],
      },
      options: {
        // cornerRadius: 20,
        tooltips: {enabled: false},
        hover: {mode: null},
        legend: {
          onClick: null
        },
        responsive: true,
        maintainAspectRatio: false,
        // scales: {
        //   xAxes: [
        //     {
        //       barPercentage: 0.2,
        //     },
        //   ],
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        // tooltips: {
        //   enabled: true
        // },
        plugins: {
          
        },
      },
    });
  }
  initiateBranchWiseChart() {
    if (this.myBarChart1) {
      this.myBarChart1.destroy();
     }
    var ctx1 = document.getElementById("myChart2");
    this.myBarChart1 = new Chart(ctx1, {
      type: "bar",
      data: {
        labels: this.salesBillLable,
        datasets: [
          {
            barThickness: 1,
            barPercentage: 0.4,
            label: "Sales",
            data: this.salesBillCount,
            backgroundColor: [
              "#2C2D87","#3b82f6","#0891b2","#059669","#d97706","#dc2626",
              "#2C2D87","#3b82f6","#0891b2","#059669","#d97706","#dc2626",
            ],
            borderColor: [
              "#2C2D87","#3b82f6","#0891b2","#059669","#d97706","#dc2626",
              "#2C2D87","#3b82f6","#0891b2","#059669","#d97706","#dc2626",
            ],
            borderWidth: 1,
             
          },
          
        ],
      },
      options: {      
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barThickness: 14,
            borderRadius:50,
        }],
          yAxes: [{
            display: true,
            ticks: {
                beginAtZero: true,
                // max: 100,
                min: 0
            }
        }],
         
          
        },
        plugins: {
          // title: {
          //   display: true,
          //   text: "Branch Wise Report",
          // },
         
        },
      },
    });
  }

  getMeetingData() {
    this.loading = true;
    let param = {
      branch_id: this.filterData.branch_id,
      report_type: "Dashboard",
      month: moment(
        moment().subtract(6, "months").format().slice(0, 10)
      ).format("YYYY-MM"),
    };
    this.cacService.getMeetingData(param).then((res) => {
      this.targetRow = res["Target Details"]
        ? res["Target Details"]
        : this.targetRow;
      this.calculateReport();
    });
  }

  // CALCULATE REPORT
  calculateReport() {
    let param = {
      // branch_id: this.filterData.branch_id,
      month: moment(
        moment().subtract(6, "months").format().slice(0, 10)
      ).format("YYYY-MM"),
      targetDate: this.getDateCount(
        moment().subtract(6, "months").format().slice(0, 10)
      ),
      targetDet: JSON.stringify(this.targetRow),
      report_type: "Dashboard",
    };
    this.loading = true;
    let that = this;
    that.cacService.calculateMeetingData(param).then((res) => {
      if (res.target && res.target.length > 0) {
        that.targetData = res.target.filter((el) => el.branch_id != -1);
        that.achievedData = res.achieved;
        that.targetAchievedData = [];

        that.targetAchievedData = that.targetData.map((itm) => {
          let locObj = that.achievedData.find(
            (item) =>
              item.branch_id == itm["branch_id"] &&
              item.dash_month == itm["dash_month"]
          );
          return {
            ...locObj,
            ...itm,
          };
        });

        if (that.targetAchievedData.length > 0) {
          let branch = that.targetAchievedData[0]["branch_id"];
          that.setMonthlyTurnOver(that.targetAchievedData[0]);
          this.getMonthTurnOverData();
        }

        console.log(that.targetAchievedData);

        that.loading = false;
      }
    });
  }

  getMonthTurnOverData() {
    this.turnOverLabel = this.targetAchievedData.filter(el => el['label_month'] == this.months.find(el1 => el1 == el['label_month'])).map(el => el['label_month']);
    this.turnOverData = this.targetAchievedData.map(el => {

      if( el['label_month'] == this.months.find(el1 => el1 == el['label_month'])){
        return (el['advancePrice'] + el['salesPrice'])?el['advancePrice'] + el['salesPrice']:0
      }

    }).filter(el => el != undefined);
    // this.monthNames.forEach((el) => {
      this.targetAchievedData
      .filter((ele) => ele.label_month == this.currentMonth)
      .forEach((res) => {
        let monthFind = this.monthNames.findIndex((el1) => el1 == res.label_month);
        if (monthFind == 11) {
          monthFind = 0;
        }
        let a =
          res["advancePrice"] + res["salesPrice"]
            ? res["advancePrice"] + res["salesPrice"]
            : 0;
        let b1 = this.targetAchievedData.find(
          (res1) =>
            res1["label_month"] == this.monthNames[monthFind - 1] &&
            res1.branch_id == res.branch_id
        );
        console.log(b1);
    
        let b = 0;
        if (b1) {
          let advance = b1["advancePrice"] ? b1["advancePrice"] : 0;
          let sales = b1["salesPrice"] ? b1["salesPrice"] : 0;
          b = advance + sales;
        }
        let reverse = 1;
        if(b > 0){
          reverse = -1
        }
    
        res["last_since"] = (100 * Math.abs((a - b) / ((a + b) / 2)) != NaN?100 * Math.abs((a - b) / ((a + b) / 2)):0) * reverse;
      });

    this.monthlyTurOverCard = this.targetAchievedData
      .filter(
        (el) =>
          el.label_month == this.currentMonth &&
          el["label_month"] ==
            this.months.find((el1) => el1 == el["label_month"])
      )
      .map((ele) => ({
        achieved:
          ele["advancePrice"] + ele["salesPrice"]
            ? ele["advancePrice"] + ele["salesPrice"]
            : 0,
        branch_id: ele.branch_id,
        branch_name: ele.branch_name,
        last_since: ele['last_since']?ele['last_since']:0,
      }));

    console.log(this.monthlyTurOverCard);
    console.log(this.turnOverData);
    console.log(this.targetAchievedData);

    this.setBranchWiseChart();
  }

  getDateCount(date, cnt = 0) {
    var now = new Date(date),
      month = now.getMonth(),
      year = now.getFullYear(),
      cur_date: any = new Date().getDate() - 1;
    if (new Date().getMonth() != month || cnt == 1) {
      cur_date = 0;
    }
    return new Date(year, month, cur_date).getDate();
  }

  getBrandsList() {
    let that = this;
    let params = {
      limit: 25,
      count: 0,
      offset: 0,
    };

    this.isLoadMask = this.dashboardService
      .getBrandsList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.brandsData = res.data;
      });
  }
//to get top and least selling
  getTopLeastSelling(): void {
    let that = this,
      params = {
        from_date: moment(this.top_from_date).format('YYYY-MM-01'),
        to_date: moment(this.top_from_date).format('YYYY-MM-31'),
        page_type: "salesReport",
        view_type: "Summary View",
        report_type: "Dashboard",
      };
      that.month = this.monthNames[this.top_from_date.getMonth()];
    that.isLoadMask = that.dashboardService
      .getTopLeastSelling(params)
      .then(function (res: any) {
        console.log("TOP LEAST stockkkkkkkkkkkkkkkkkkkkkkk",res);
        that.loadingIndicator = false;
        that.sellingData.push(res.data);
        that.sellingData.push(res.least);

        
      //   that.sellingData[0].forEach((el : any) => {
      //     el.qty -= el.rtn_qty;
      //     el.sold_price -= el.rtn_sold_price;
      //     console.log("TOP LEAST stock reduceeeeeeeeeeeeeeeeeeeeeee",el.qty);
      //     console.log("TOP LEAST stock reduceeeeeeeeeeeeeeeeeeeeeee",el.rtn_qty);
      // });
 
      // that.sellingData[0].forEach((top : any) => {
      //   that.sellingData[1].forEach((least : any )=>{
      //     console.log("testttttttttttttttt",top.qty);
      //     let topItem=top.qty;
      //     let leastItem=least.qty;
      //     that.addition=topItem;
      //     console.log('TOP testttttttttttttttt',that.addition);
      //     let sortItems=that.addition;
      //     that.display=sortItems.sort((a:any,b:any) => b - a);
         
      //   })
      // });
      // let arr= that.sellingData[0][0].qty;
      // let arr1=that.sellingData[0][1].qty;
      // let arr2=that.sellingData[0][2].qty;
      // that.concatarr.push(arr);
      // that.concatarr.push(arr1);
      // that.concatarr.push(arr2);
      // that.concatarr.push(res.data);
      // let sortArray=that.concatarr;
      // console.log('pushhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh',sortArray);
      // console.log("concattttttttttttttttttttttttttt",that.concatarr);
      // let sortedArray = sortArray.sort((a, b) => b - a);
      // console.log("sort arrayyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy",sortedArray);
      // that.addition=that.sellingData[0][0].qty.concat(that.sellingData[1][0].qty);
      // console.log('TOP concattttttttttttttttttttttttttttttttttttttt',that.addition);
      // that.display=that.addition.sort((a,b) => b - a);

      // console.log('TOP sortttttttttttttttttttttttttttttttttt',that.display);
        that.topSellingData = res.data.slice(0, 3);
       
        // let value = [100, 50, 25];
        // that.topSellingData.forEach((element, i) => {
        //   element["value"] = value[i];
        // });
      //   that.sellingData[1].forEach((ele : any) => {
      //     ele.qty -= ele.rtn_qty;
      //     ele.sold_price -= ele.rtn_sold_price;
         
      // });
        that.leastSellingData = res.least.slice(Math.max(res.least.length - 3, 0));
        
        // debugger;
        // that.leastSellingData.sort(function(a,b){return a-b});
        // console.log(that.leastSellingData);
        // that.leastSellingData.forEach((element, i) => {
        //   element["value"] = value[i];
        // });
      });
  }
  //to get user name on sales conversion ratio
  getUserList(): void {
    let that = this;
    this.userService.getDashboardUserList()
        .then(function(res: any) {
            that.branchData = res.data;
            that.getSalesConvRatio();
        });
}
//sales conversion ratio
  getSalesConvRatio(): void {
    if (!this.username) return;
    this.usernameComp=this.branchData.find(obj => obj.username == this.username);
    if (!this.usernameComp) return;
    var userids=this.usernameComp.userid;
    let that = this,
   
      params = {
        from_date: moment(this.from_date).format('YYYY-MM-DD'),
        to_date: moment(this.to_date).format('YYYY-MM-DD'),
        userid:userids,
        page_type: "salesReport",
        view_type: "Summary View",
        report_type: "Dashboard",
      };
      
     
    that.isLoadMask = that.dashboardService
    .getSalesConvRatio(params)
      .then(function (res: any) {
     
        that.loadingIndicator = false;

        that.salesConvData = res.data.slice(0, 3);
        var a= that.salesConvData;
        // console.log("saless",that.salesConvData);
        a=Math.ceil(res.data[0].sold_count);
        // console.log("sold counttt",that.salesConvData);
        
      });
  }
  //to get service quantity and value
  getServiceValue(): void {
    let that = this,
      params = {
        from_date: moment(this.service_from_date).format('YYYY-MM-01'),
        to_date: moment(this.service_from_date).format('YYYY-MM-31'),  
        page_type: "salesReport",
        view_type: "Summary View",
        report_type: "Dashboard",
      };
      
     
    that.isLoadMask = that.dashboardService
    .getServiceValue(params)
      .then(function (res: any) { 
        console.log(res);    
        that.loadingIndicator = false;
     
         that.serviceValueData = [];  
        that.serviceValueData.push(res.data[0]);
        that.serviceValueData.push(res.company[0]);
        that.serviceValueData.push(res.total[0]);
        console.log(that.serviceValueData.res);
     
      });
    
  }

  
  getSalesMonthList(): void {
    let that = this,
      params = {
        monthType :this.monthListType,
        // from_date: moment(this.count_from_date).format('YYYY-MM-01'),
        // to_date: moment(this.count_from_date).format('YYYY-MM-31'),
        page_type: "salesReport",
        view_type: "Summary View",
        report_type: "Dashboard",
      };
    //  that.name = this.monthNames[this.count_from_date.getMonth()];
      
      // params.from_date.toLocaleString('default', { month: 'long' });
       
    that.isLoadMask = that.dashboardService
      .getSalesMonthList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.salesBillLable =[];
        that.salesBillCount =[];
        for(var i=0;i< res.data.length; i++)
        {
          that.salesBillLable = that.salesBillLable.concat(res.data[i].month);
          that.salesBillCount = that.salesBillCount.concat(res.data[i].amount);
        }
    
        that.initiateBranchWiseChart();
       
      });
  }

  
  getSalesServiceSpareCount(): void {
    let that = this,
      params = {
        from_date: moment(this.count_from_date).format('YYYY-MM-01'),
        to_date: moment(this.count_from_date).format('YYYY-MM-31'),
        page_type: "salesReport",
        view_type: "Summary View",
        report_type: "Dashboard",
      };
     that.name = this.monthNames[this.count_from_date.getMonth()];
      
      // params.from_date.toLocaleString('default', { month: 'long' });
       
    that.isLoadMask = that.dashboardService
      .getSalesServiceSpareCount(params)
      .then(function (res: any) {        
        that.loadingIndicator = false;
        that.salesServiceSpareLable =[];
        that.salesSpareServiceCount =[];
        console.log("pie chartttttttttttttttttttttt",res);
        that.salesAmt = parseInt(res.data[0].SALES) - parseInt(res.data[0].salesRetAmt);
        that.salesAmt = parseFloat(that.salesAmt).toFixed(2);
        that.serviceAmt = res.data[0].SERVICE;
        that.spareAmt = res.data[0].SPARES;
        // res.data[0].slice(0,-1);
        res.data[0].SALES = res.data[0].SALES - res.data[0].salesRetAmt;
        res.data[0].SALES = parseFloat(res.data[0].SALES).toFixed(2);
       
        for (var key in res.data[0]) {
         
          that.salesServiceSpareLable = that.salesServiceSpareLable.concat(key+"-"+res.data[0][key]);
         }
      console.log(that.salesServiceSpareLable);
   
        for (var key in res.data[0]) {
          if(key != 'salesRetAmt')
          {
            that.salesSpareServiceCount = that.salesSpareServiceCount.concat(res.data[0][key]);
          }
     
      }
       
        that.setTurnOverChart();
       
      });
  }

  setMonthlyTurnOver(card) {
    this.currentBranch = card.branch_name;
    let branch = card.branch_id;
    this.turnOverLabel = this.targetAchievedData
      .filter(
        (el) =>
          el["branch_id"] == branch &&
          el["label_month"] ==
            this.months.find((el1) => el1 == el["label_month"])
      )
      .map((el) => el["label_month"]);
    this.turnOverData = this.targetAchieved = this.targetAchievedData
      .map((el) => {
        if (
          el.branch_id == branch &&
          el["label_month"] ==
            this.months.find((el1) => el1 == el["label_month"])
        ) {
          return el["advancePrice"] + el["salesPrice"]
            ? el["advancePrice"] + el["salesPrice"]
            : 0;
        }
      })
      .filter((el) => el != undefined);


  }

  setBranchWiseChart() {
    let targetAchieved = this.targetAchievedData.filter(
      (el) =>
        el["label_month"] == this.months.find((el1) => el1 == el["label_month"])
    );

    this.targetAchieved = [];
    this.monthlyTarget = [];
    let targetMonthlyAchieved = [];
    let that = this;
    targetAchieved.reduce(function (res, value) {
      if (!res[value.branch_id]) {
        res[value.branch_id] = {
          branch_name: value.branch_name,
          branch_id: value.branch_id,
          achievedValue: 0,
          targetMonth: value.month_target,
        };

        targetMonthlyAchieved.push(res[value.branch_id]);
      }
      let targetqty =
        value["advancePrice"] + value["salesPrice"]
          ? value["advancePrice"] + value["salesPrice"]
          : 0;
      res[value.branch_id]["achievedValue"] += targetqty;
      res[value.branch_id]["targetMonth"] += value.month_target;

      return res;
    }, {});

    that.targetAchieved = targetMonthlyAchieved.map((el) => el.achievedValue);
    that.monthlyTarget = targetMonthlyAchieved.map((el) => el.targetMonth);
    that.branchWiseLabel = targetMonthlyAchieved.map((el) => el.branch_name);

    console.log(that.targetAchieved);

    that.initiateBranchWiseChart();
  }

  relDiff(a, b) {
    return 100 * Math.abs((a - b) / ((a + b) / 2));
  }
  clearFilter(): void {
    this.saleConvData = {
      "search_data": "",
      // "from_date":new Date(),
      // "to_date":new Date()
  };
    this.applyFilter();
}
  applyFilter(): void {
    //this.filterExpand = false;
    this.page.offset = 0;

    this.getSalesConvRatio();
}
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/home/dashboard.component.ts